import Axios from "@app/api/axios";

import { BILLING_ACCOUNTS } from "@utils/constant";

export const getBillingAccountsListService = (query) =>
  Axios.get(`${BILLING_ACCOUNTS}?${query}`);
